module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Limited time annuity special offer":"Limited time annuity special offer","Limited time pro special offer":"Limited time Pro plan annuity special offer","discount_off":"off"},"pt":{"Limited time annuity special offer":"Oferta na anuidade por tempo limitado","Limited time pro special offer":"Oferta na anuidade do plano Pro por tempo limitado","discount_off":"de desconto"}}')
  delete Component.options._Ctor
}
